module.exports = __webpack_public_path__ + "static/media/img_0.8dfc4378.png";